// source: pbtypes/gen/skills/joysticks_inputs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_joysticks_kind_pb = require('../../../pbtypes/gen/skills/joysticks_kind_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_joysticks_kind_pb);
var pbtypes_gen_skills_ui_axis_pb = require('../../../pbtypes/gen/skills/ui_axis_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_ui_axis_pb);
goog.exportSymbol('proto.skills.JoysticksInputs', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.JoysticksInputs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.JoysticksInputs.repeatedFields_, null);
};
goog.inherits(proto.skills.JoysticksInputs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.JoysticksInputs.displayName = 'proto.skills.JoysticksInputs';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.JoysticksInputs.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.JoysticksInputs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.JoysticksInputs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.JoysticksInputs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.JoysticksInputs.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
deviceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
kind: jspb.Message.getFieldWithDefault(msg, 3, 0),
axesList: jspb.Message.toObjectList(msg.getAxesList(),
    pbtypes_gen_skills_ui_axis_pb.UiAxis.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.JoysticksInputs}
 */
proto.skills.JoysticksInputs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.JoysticksInputs;
  return proto.skills.JoysticksInputs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.JoysticksInputs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.JoysticksInputs}
 */
proto.skills.JoysticksInputs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {!proto.skills.JoysticksKind.Enum} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 4:
      var value = new pbtypes_gen_skills_ui_axis_pb.UiAxis;
      reader.readMessage(value,pbtypes_gen_skills_ui_axis_pb.UiAxis.deserializeBinaryFromReader);
      msg.addAxes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.JoysticksInputs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.JoysticksInputs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.JoysticksInputs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.JoysticksInputs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAxesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      pbtypes_gen_skills_ui_axis_pb.UiAxis.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.skills.JoysticksInputs.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.JoysticksInputs} returns this
 */
proto.skills.JoysticksInputs.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string device_id = 2;
 * @return {string}
 */
proto.skills.JoysticksInputs.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.JoysticksInputs} returns this
 */
proto.skills.JoysticksInputs.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional JoysticksKind.Enum kind = 3;
 * @return {!proto.skills.JoysticksKind.Enum}
 */
proto.skills.JoysticksInputs.prototype.getKind = function() {
  return /** @type {!proto.skills.JoysticksKind.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.skills.JoysticksKind.Enum} value
 * @return {!proto.skills.JoysticksInputs} returns this
 */
proto.skills.JoysticksInputs.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated UiAxis axes = 4;
 * @return {!Array<!proto.skills.UiAxis>}
 */
proto.skills.JoysticksInputs.prototype.getAxesList = function() {
  return /** @type{!Array<!proto.skills.UiAxis>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_skills_ui_axis_pb.UiAxis, 4));
};


/**
 * @param {!Array<!proto.skills.UiAxis>} value
 * @return {!proto.skills.JoysticksInputs} returns this
*/
proto.skills.JoysticksInputs.prototype.setAxesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.skills.UiAxis=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.UiAxis}
 */
proto.skills.JoysticksInputs.prototype.addAxes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.skills.UiAxis, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.JoysticksInputs} returns this
 */
proto.skills.JoysticksInputs.prototype.clearAxesList = function() {
  return this.setAxesList([]);
};


goog.object.extend(exports, proto.skills);
